<script>
import axios from 'axios'
import { Toast } from 'vant'
export default {
  data: {
    // post: 'http://192.168.0.166:8090'
    post: 'https://icmp.shingsou.com',
  },
  /* 加载中 */
  showLoading (text) {
    Toast.loading({
      message: text,
      forbidClick: true,
      duration: 0,
      forbidClick: true
    })
  },
  /* 成功提示 */
  showSucces (text, timeNum) {
    Toast.success({ message: text, duration: timeNum })
  },
  /* 失败提示 */
  showError (text, timeNum) {
    Toast.fail({ message: text, duration: timeNum })
  },
  requestUrl (url, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(this.data.post + url, data)
        .then(response => {
          if (response.data.success)          {
            resolve(response.data.result ? response.data.result : response.data)
          } else          {
            if (response.data.msg == '当前用户有欠费，余额为-1元，不能办理该业务')            {
              resolve(response.data.result ? response.data.result : response.data)
              return
            }
            Toast.fail({
              message: response.data.msg,
              onClose () {
                resolve(response.data.result ? response.data.result : response.data)
              }
            })
          }
        })
        .catch(error => {
          Toast.fail({ message: '请求服务器失败,请稍后重试!' })
        })
    })
  },
  //TrafficTopButton.vue
  //监听页面大小，选择合适的图片
  imgs (that) {
    let clientWidth = document.documentElement.clientWidth
    if (clientWidth < 650)    {
      that.zfb = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/zPay.png'
      that.wx = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/wPay.png'
    } else if ((clientWidth >= 650) & (clientWidth < 800))    {
      that.zfb = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/zPay_max.png'
      that.wx = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/wPay_max.png'
    } else    {
      that.zfb = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/zPay_max%2B.png'
      that.wx = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/wPay_max%2B.png'
    }
  },
  //监听打开该项目的系统
  detectDeviceType () {
    const machineType = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop'
    if (machineType === 'Mobile')    {
      console.log('移动端')
    } else    {
      console.log('Pc端')
    }
  },
  //监听打开的系统，修改不同的跳转支付宝支付路径
  detectDeviceType (that) {
    const machineType = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop'
    if (machineType === 'Mobile')    {
      that.payPost = '/aliPay/wapPay'
    } else    {
      that.payPost = '/aliPay/pagePay'
    }
  },
  //recharge.vue
  //验证卡号输入框的正则
  verify (that) {
    if (/^[\da-z]{11}$/i.test(that.msisdnNum) | /^[\da-z]{13}$/i.test(that.msisdnNum) | /^[\da-z]{15}$/i.test(that.msisdnNum) | /^[\da-z]{19}$/i.test(that.msisdnNum) | /^[\da-z]{20}$/i.test(that.msisdnNum)) return true
    else    {
      Toast('流量卡号格式不正确,请检查流量卡号')
      return false
    }
  }
}
</script>
